import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * module decorationRegistration
 * author xuyuxiong
 * description 装修登记
 */
import { fetchList, fetchDelete } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchDecorationDetail } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import deliveryAdd from './add';
import houseDetail from '@/views/PMS/baseInformation/WuyeZiyuanManager/house/detail';
import customerDetail from '@/views/PMS/baseInformation/customer/detail';
import { formatJson } from '@/utils/index';
import addCharge from '@/views/PMS/customerService/houseDeliveryManage/decorationRegistration/addCharge';
import decorationCharge from '@/views/PMS/customerService/houseDeliveryManage/decorationRegistration/charge';
import decorationCheck from './check';
import completionAcceptance from './completionAcceptance';
export default {
  components: {
    deliveryAdd: deliveryAdd,
    houseDetail: houseDetail,
    customerDetail: customerDetail,
    addCharge: addCharge,
    decorationCharge: decorationCharge,
    decorationCheck: decorationCheck,
    completionAcceptance: completionAcceptance
  },
  data: function data() {
    return {
      customerId: '',
      decorateId: '',
      houseId: '',
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      downloadLoading: false,
      dialogHouseFormVisible: false,
      dialogCustomerFormVisible: false,
      dialogChargeFormVisible: false,
      dialogCheckFormVisible: false,
      dialogAddChargeFormVisible: false,
      dialogAcceptanceFormVisible: false,
      listQuery: {
        limit: 10,
        page: 1,
        upIdList: []
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      total: 0,
      title: '',
      cascaderItem: [],
      floorOption: [],
      buildingOptions: [],
      startDates: [],
      endDates: [],
      selectData: [],
      multipleSelection: []
    };
  },
  created: function created() {
    this.cascaderItem = [];
    this.floorOption = [];
    this.buildingOptions = [];
    this.getList();
    this.loadBuiildingTree();
  },
  methods: {
    loadBuiildingTree: function loadBuiildingTree() {
      var _this = this;

      var treeQuery = {
        flag: 2
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.buildingOptions = response.data.data;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList: function getList() {
      var _this2 = this;

      fetchList(this.listQuery).then(function (res) {
        _this2.list = res.data.data;
        _this2.total = res.data.total;
      });
    },
    getSelectData: function getSelectData(data) {
      this.selectData = data;
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this3 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this3.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    checkSelectBuild: function checkSelectBuild(val) {
      if (val) {
        this.listQuery.buildingId = '';
        this.cascaderItem = [];
        this.getCascaderItem(this.listQuery.upIdList, this.buildingOptions);

        if (this.cascaderItem.length > 0 && this.cascaderItem[this.cascaderItem.length - 1].flag !== '2') {
          this.$message({
            message: '请选择正确的楼栋',
            type: 'error',
            duration: 3000
          });
          this.listQuery.upIdList = [];
          return;
        }

        this.listQuery.buildingId = this.listQuery.upIdList[this.listQuery.upIdList.length - 1];
      }
    },
    handleUpload: function handleUpload() {
      var _this4 = this;

      this.$confirm('你确定是要导出这些装修登记记录吗, 是否继续?', '提示').then(function () {
        if (_this4.list !== null && _this4.list.length > 0) {
          _this4.downloadLoading = true;
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/vendor/Export2Excel'));
          }).then(function (excel) {
            var tHeader = ['小区名称', '楼栋', '房间代码', '建筑面积(m²)', '客户名称', '装修开始时间', '装修结束时间', '状态'];
            var filterVal = ['areaName', 'buildingName', 'houseCode', 'houseArea', 'customerName', 'beginDate', 'expectEndDate', 'stateName'];
            var data = formatJson(filterVal, _this4.list);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: '装修登记记录',
              autoWidth: true,
              bookType: 'xlsx'
            });
            _this4.downloadLoading = false;
          });
        } else {
          _this4.Alert({
            alertType: 'error',
            message: '暂无数据，无法导出!'
          });
        }
      });
    },
    handleFilter: function handleFilter() {
      if (this.startDates !== null && this.startDates.length > 0) {
        this.listQuery.sBeginDate = this.startDates[0];
        this.listQuery.sEndDate = this.startDates[1];
      } else {
        this.listQuery.sBeginDate = '';
        this.listQuery.sEndDate = '';
      }

      if (this.endDates !== null && this.endDates.length > 0) {
        this.listQuery.eBeginDate = this.endDates[0];
        this.listQuery.eEndDate = this.endDates[1];
      } else {
        this.listQuery.eBeginDate = '';
        this.listQuery.eEndDate = '';
      }

      this.getList();
    },
    handleAddCharge: function handleAddCharge(houseId) {
      this.houseId = houseId;
      this.dialogAddChargeFormVisible = true;
    },
    decorationRegistration: function decorationRegistration() {
      this.decorateId = -1;
      this.dialogFormVisible = true;
      this.title = '装修登记';
    },
    handleComplete: function handleComplete(id) {
      this.dialogAcceptanceFormVisible = true;
      this.decorateId = id;
      this.title = '完成验收';
    },
    handleCharge: function handleCharge(id) {
      var _this5 = this;

      fetchDecorationDetail({
        id: id
      }).then(function (res) {
        if (res.data.code === 200) {
          _this5.dialogChargeFormVisible = true;
          _this5.decorateId = id;
          _this5.title = '收费';
        }
      });
    },
    handleCheck: function handleCheck(id) {
      this.dialogCheckFormVisible = true;
      this.decorateId = id;
      this.title = '查看';
    },
    handleUpdate: function handleUpdate(id) {
      this.dialogFormVisible = true;
      this.decorateId = id;
      this.title = '编辑';
    },
    delete: function _delete(decorateIds) {
      var _this6 = this;

      if (decorateIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(decorateIds).then(function (response) {
            _this6.getList();

            _this6.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(decorateId) {
      var decorateIds = [];
      decorateIds.push(decorateId);
      this.delete(decorateIds);
    },
    getRoomDetail: function getRoomDetail(houseId) {
      this.dialogHouseFormVisible = true;
      this.houseId = houseId;
      this.title = '房间详情';
    },
    getCustomerDetail: function getCustomerDetail(customerId) {
      this.dialogCustomerFormVisible = true;
      this.customerId = customerId;
      this.title = '客户详情';
    },
    handCancle: function handCancle(flag) {
      if (flag === 'charge') {
        this.dialogAddChargeFormVisible = false;
      } else {
        this.getList();
        this.dialogChargeFormVisible = false;
        this.dialogFormVisible = false;
        this.dialogHouseFormVisible = false;
        this.dialogCustomerFormVisible = false;
        this.dialogAcceptanceFormVisible = false;
      }
    }
  }
};